import React from "react";
import background from "assets/images/full-background.svg";

function Loader() {
  return (
    <div
      className="flex justify-center items-center h-screen w-full bg-cover bg-no-repeat bg-center bg-cape-cod-700"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <div className="flex flex-col justify-center">
        <svg width={175} height={112.5} viewBox="0 0 235.186 151.199">
          <defs>
            <linearGradient
              id="prefix__a"
              x1={-0.344}
              y1={0.486}
              x2={2.114}
              y2={0.524}
              gradientUnits="objectBoundingBox"
            >
              <stop offset={0.451} stopColor="#edeeef" />
              <stop offset={0.864} stopColor="#5a5b5e" />
            </linearGradient>
            <linearGradient
              id="prefix__b"
              x1={0.514}
              y1={-0.409}
              x2={0.435}
              y2={2.64}
              gradientUnits="objectBoundingBox"
            >
              <stop offset={0} stopColor="#e4ac58" />
              <stop offset={1} stopColor="#9e6623" />
            </linearGradient>
            <linearGradient
              id="prefix__c"
              x1={1.175}
              y1={1.553}
              x2={-0.139}
              y2={0.189}
              xlinkHref="#prefix__b"
            />
            <linearGradient
              id="prefix__d"
              x1={58.816}
              y1={1.553}
              x2={57.502}
              y2={0.189}
              xlinkHref="#prefix__b"
            />
            <linearGradient
              id="prefix__e"
              x1={0.513}
              y1={-0.497}
              x2={0.47}
              y2={2.818}
              xlinkHref="#prefix__a"
            />
            <style>
              {
                ".prefix__a{fill:#fff}.prefix__b{fill:#a6a6a7}.prefix__c{fill:#bbbcbd}.prefix__d{fill:#c7c9cb}"
              }
            </style>
          </defs>
          <path
            className="prefix__a"
            d="M0 141.556v-22.639a2.3 2.3 0 012.551-2.552h5.366c11.229 0 15.6 4.764 15.6 13.884 0 8.995-4.369 13.859-15.6 13.859H2.551A2.3 2.3 0 010 141.556zm17.4-11.357c0-5.738-2.251-8.5-9.293-8.5H6.048v17.027h2.111c6.991-.002 9.242-2.75 9.242-8.528zM27.061 133.149c0-6.744 4.585-11.314 11.24-11.314 6.374 0 10.444 3.907 10.847 10.089.108 1.7-.8 2.554-2.556 2.554H32.879c.1 3.59 2.3 5.673 5.867 5.673a6.522 6.522 0 004.529-1.565c.954-.788 1.541-1.31 2.867-.989l.525.129c1.749.425 2.044 1.4.945 2.795-1.861 2.532-5 3.946-9.135 3.946-6.909-.004-11.416-4.447-11.416-11.318zm16.71-2.476a4.946 4.946 0 00-5.33-4.8 5.077 5.077 0 00-5.461 4.8h10.791zM53.316 141.556v-23.942a2.3 2.3 0 012.556-2.551h.753a2.3 2.3 0 012.547 2.551v23.942a2.3 2.3 0 01-2.552 2.552h-.748a2.3 2.3 0 01-2.556-2.552zM63.687 116.559c0-1.9 1.392-2.934 3.318-2.934 1.761 0 3.318 1.034 3.318 2.934s-1.558 2.936-3.318 2.936c-1.929-.001-3.318-1.022-3.318-2.936zm.382 25v-16.817a2.287 2.287 0 012.521-2.552h.743a2.289 2.289 0 012.523 2.552v16.817a2.289 2.289 0 01-2.523 2.552h-.743a2.287 2.287 0 01-2.521-2.552zM80.714 142.161l-7.158-17.015c-.732-1.744.075-2.944 1.938-2.944h.995a2.88 2.88 0 012.935 2.059l5.081 13.3 5.069-13.3a2.877 2.877 0 012.931-2.059h.995c1.913 0 2.711 1.215 1.975 2.953l-7.2 17.012a2.918 2.918 0 01-2.951 1.966h-1.627a2.959 2.959 0 01-2.983-1.972zM97.703 133.149c0-6.744 4.585-11.314 11.24-11.314 6.374 0 10.444 3.907 10.845 10.089.11 1.7-.794 2.554-2.554 2.554h-13.713c.1 3.59 2.3 5.673 5.867 5.673a6.522 6.522 0 004.529-1.565c.954-.788 1.541-1.31 2.867-.989l.525.129c1.749.425 2.044 1.4.945 2.795-1.861 2.532-5 3.946-9.135 3.946-6.909-.004-11.416-4.447-11.416-11.318zm16.71-2.476a4.946 4.946 0 00-5.33-4.8 5.077 5.077 0 00-5.461 4.8h10.791zM136.897 124.599l-.048.423c-.177 1.582-1.088 2.034-2.674 2.31-2.9.49-4.4 2.428-4.4 6.443v7.782a2.3 2.3 0 01-2.552 2.552h-.714a2.3 2.3 0 01-2.552-2.552v-16.815a2.3 2.3 0 012.552-2.552h.714c1.647 0 2.552.773 2.552 2.347v.973a5.214 5.214 0 015.056-3.542c1.566 0 2.25.974 2.066 2.631zM144.649 148.523l1.945-4.516-7.885-18.865c-.73-1.749.086-2.94 1.949-2.94h1.034a2.87 2.87 0 012.918 2.072l5.094 13.468 5.081-13.468a2.869 2.869 0 012.919-2.072h.98c1.915 0 2.735 1.2 2.014 2.94l-9.975 24.086a2.929 2.929 0 01-2.988 1.971h-1.071c-1.874 0-2.699-1.09-2.015-2.676zM164.703 141.556v-22.639a2.3 2.3 0 012.552-2.552h6.884c9.274 0 11.866 3.128 11.866 7.368 0 3.59-1.837 5.66-4.714 6.273 3.26.55 5.558 2.517 5.558 6.4 0 4.317-2.722 7.7-12.237 7.7h-7.357a2.3 2.3 0 01-2.552-2.55zm15.026-17.03c0-2.314-1.3-3.182-5.6-3.182h-3.465v6.7h3.544c3.946-.005 5.521-1.102 5.521-3.515zm.868 11.154c0-2.545-1.407-3.566-5.895-3.566h-4.041v7.068h3.989c4.335 0 5.947-1.163 5.947-3.503zM190.039 133.149c0-7.9 5.608-11.314 11.329-11.314s11.329 3.419 11.329 11.314c0 7.97-5.582 11.367-11.329 11.367s-11.329-3.396-11.329-11.367zm16.851-.013c0-4.1-2.275-6.558-5.535-6.558s-5.524 2.429-5.524 6.558c0 4.179 2.277 6.6 5.55 6.6s5.509-2.447 5.509-6.6zM215.14 141.019l6.31-8.419-5.444-7.305c-1.28-1.716-.753-3.093 1.109-3.093h1.354a3.088 3.088 0 012.947 1.455l3.4 4.822 3.378-4.8a3.109 3.109 0 012.949-1.481h1.122c2.018 0 2.675 1.375 1.39 3.091l-5.468 7.307 6.286 8.417c1.282 1.714.768 3.091-1.043 3.091h-1.3a3.273 3.273 0 01-3.076-1.671l-4.209-5.934-4.285 5.934a3.276 3.276 0 01-3.076 1.671h-1.3c-1.814.004-2.328-1.371-1.044-3.085z"
          />
          <g>
            <path
              className="prefix__b"
              d="M141.743 81.979l-13.718-.881S132.465.529 133.137.351a29.173 29.173 0 016.318-.348c3.24-.024 6.532.261 7.518.7 1.257.569-5.23 81.276-5.23 81.276z"
            />
            <path
              className="prefix__c"
              d="M145.552 28.313l-13.718-.883s.4-28.218 1.386-27.048c1.943 2.32 12.3 1.3 13.753.324 1.079-.723-1.421 27.607-1.421 27.607z"
            />
            <path
              className="prefix__d"
              d="M141.644 91.271l-14.974-.963s2.228-89.819 2.778-86.393c.3 1.9 16.445-.1 17.906-1.36 1.094-.944-5.71 88.716-5.71 88.716z"
            />
            <path
              className="prefix__b"
              d="M118 75.521l-13.653-1.6s5.492-53.345 6.165-53.416c1.492-.155 4.376.43 7.145.622 3.231.224 5.656.265 6.633.633 1.244.47-6.29 53.761-6.29 53.761z"
            />
            <path
              className="prefix__c"
              d="M122.506 40.049l-13.654-1.6s.779-18.769 1.74-17.917c1.906 1.688 12.237 1.768 13.7 1.228 1.08-.402-1.786 18.289-1.786 18.289z"
            />
            <path
              className="prefix__d"
              d="M117.78 81.705l-14.9-1.744s6.012-60.63 6.513-58.307c.278 1.287 13.783 2.1 15.255 1.366 1.098-.548-6.868 58.685-6.868 58.685z"
            />
            <path
              className="prefix__b"
              d="M85.833 78.159l13.356-.209s-.291-63.754-.933-63.92c-1.429-.367-4.048-.056-6.744-.17-3.143-.132-5.714-.354-6.694-.039-1.252.401 1.015 64.338 1.015 64.338z"
            />
            <path
              className="prefix__c"
              d="M84.816 35.662l13.349-.211s1.014-22.29.006-21.4c-1.043.918-2.832 1.7-5.861 1.485a28.374 28.374 0 01-7.5-1.716c-1.007-.608.006 21.842.006 21.842z"
            />
            <path
              className="prefix__d"
              d="M85.465 85.499l14.573-.231s1.55-68.762.619-68.289c-2.552 1.295-14.951-.667-16.306-1.712-1.014-.784 1.114 70.232 1.114 70.232z"
            />
            <path
              d="M105.015 84.86l-42.027-.138c-3.005-.009-5.457-2.092-5.448-4.63s2.472-4.6 5.477-4.592l32.289.106c3.005.009 5.47-2.057 5.477-4.594s-2.443-4.619-5.448-4.628l-39.113-.129c-3.005-.009-5.457-2.092-5.448-4.63s2.472-4.6 5.477-4.592l49.01.162a21.189 21.189 0 00-.168 2.9zm0 .007l-21.1-.071c3.005.011 5.455 2.094 5.448 4.63S86.906 94 83.92 94.013l-37.376-.123c-3.005-.009-5.47 2.057-5.477 4.594s2.442 4.619 5.448 4.628l58.439.192z"
              transform="translate(-26.274 -9.421)"
              fill="url(#prefix__a)"
            />
            <path
              d="M181.271 63.453L155.1 47.962l-.031.052v-.052H74.035v10.944l.037 52.227h81V58.888z"
              transform="translate(2.18 -17.25)"
              fill="url(#prefix__b)"
            />
            <path
              d="M117.532 47.962l26.2 15.491-26.2-4.565z"
              transform="translate(39.721 -17.25)"
              fill="url(#prefix__c)"
            />
            <path
              d="M86.169 47.962l-26.2 15.491 26.2-4.565z"
              transform="translate(-9.959 -17.25)"
              fill="url(#prefix__d)"
            />
            <path
              transform="translate(125.601 78.982)"
              style={{
                mixBlendMode: "soft-light",
                isolation: "isolate",
              }}
              fill="url(#prefix__e)"
              d="M0 0h24.74v7.275H0z"
            />
          </g>
        </svg>
        <div className="gradient-underline my-10" />
        <p className="text-white text-lg text-center tracking-widest">
          Loading...
        </p>
      </div>
    </div>
  );
}
export default Loader;
